<template>
  <section class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Výrobci - Přidat</strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <h4 class="text-black mt-4 mb-3"><strong>Nastavitelné podle jazyka</strong></h4>

        <a-form-item
          label="Popisek"
          :validate-status="error('mle_description') ? 'error' : ''"
          :help="error('mle_description') || ''"
        >
          <a-input
            :autosize="{ minRows: 4, maxRows: 10 }"
            type="textarea" placeholder="Popisek" v-decorator="['mle_description']"/>
        </a-form-item>

        <h4 class="text-black mt-4 mb-3"><strong>Ostatní</strong></h4>

        <a-form-item
          label="Název"
          :validate-status="error('mur_name') ? 'error' : ''"
          :help="error('mur_name') || ''"
        >
          <a-input placeholder="Název" v-decorator="['mur_name', {rules: [{max: 100, message: 'Název nemůže být delší než 100 znaků!'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="URL"
          :validate-status="error('mur_url') ? 'error' : ''"
          :help="error('mur_url') || ''"
        >
          <a-input placeholder="URL" v-decorator="['mur_url', {rules: [{type: 'url', message: 'URL není ve správném formátu!'}, {max: 200, message: 'URL nemůže být delší než 200 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Logo výrobce&nbsp;
            <a-tooltip title="Můžete si vybrat z již existujících obrázků.">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <small>Logo výrobce již existuje v systému:&nbsp;</small>
          <a-switch checkedChildren="Ano" unCheckedChildren="Ne" v-model="image.switch" @change="onImageSwitchChange"/>
          <div v-if="this.image.switch">
            <a-row class="pb-5" type="flex" justify="center">
              <a-col :span="8">
                <a-input-search
                  placeholder="Hledat..."
                  v-model="image.search"
                />
              </a-col>
            </a-row>
            <div v-if="images.data.length > 0">
              <a-row>
                <a-radio-group v-decorator="['existing']" name="image" :class="$style.gallery">
                  <a-col :key="index" v-for="(item, index) in images.data" :xl="4" :md="6" :sm="8" :xs="12">
                    <div :class="{[$style.active]: item.iae_id === form.getFieldValue('existing'), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                      <img v-if="!image.errors.includes(item.iae_id)" class="img-fluid" :src="$uploadImagePath + item.iae_path + '_6.' + item.iae_format" @error="image.errors.push(item.iae_id)">
                      <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                      <div :class="$style.itemControls">
                        <span :class="$style['item-name']">{{ toImageName(item.iae_name) }}</span>
                        <a-radio :class="$style['ant-radio-wrapper']" :value="item.iae_id"/>
                      </div>
                    </div>
                  </a-col>
                </a-radio-group>
              </a-row>
              <a-row class="pb-5 pt-5" type="flex" justify="center">
                <a-col :span="8">
                  <a-button v-if="imageNextCount > 0" type="primary" class="width-200 d-block m-auto" @click="onNextImagesClick">Načíst dalších {{ imageNextCount }}...</a-button>
                </a-col>
              </a-row>
            </div>
            <a-empty v-else>
              <a-spin v-if="!image.loaded" />
            </a-empty>
          </div>
          <a-upload-dragger
            v-else
            :fileList="this.item.iae_id.new"
            name="file"
            :multiple="false"
            :beforeUpload="beforeUpload"
            :remove="handleRemove"
            :disabled="this.image.switch"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox"/>
            </p>
            <p class="ant-upload-text">Chcete-li nahrát soubor, klikněte nebo přetáhněte soubor do této oblasti</p>
          </a-upload-dragger>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Přidat</a-button>
        </div>
      </a-form>
    </div>
  </section>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'

export default {
  components: {
    ActionTools, LanguageTab,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/ecommerce/manufacturer',
          title: 'Seznam',
        },
      ],
      image: {
        switch: false,
        search: '',
        page: 1,
        url: '',
        loaded: false,
        errors: [],
      },
      item: {
        iae_id: {
          existing: null,
          new: [],
        },
        languages: [],
      },
    }
  },
  computed: {
    images: function () {
      return this.$store.getters['image/filteredItems']({ searchText: this.image.search, page: this.image.page })
    },
    imageNextCount: function () {
      const imageCount = this.images.count - this.images.data.length
      return imageCount > 6 ? 6 : imageCount
    },
    language: function () {
      return this.$store.getters['language/active']
    },
  },
  methods: {
    toImageName: function (name) {
      const maxLength = 30
      const nameSubstring = name.substring(0, maxLength)
      return nameSubstring.length !== maxLength ? nameSubstring : nameSubstring + '...'
    },
    onNextImagesClick() {
      this.image.page += 1
    },
    onImageSwitchChange(checked) {
      this.item.iae_id.new = []
      if (checked && !this.image.loaded) {
        this.loading = true
        this.$store.dispatch('image/getList')
          .catch(() => {})
          .finally(() => {
            this.loading = false
            this.image.loaded = true
          })
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('manufacturer/post', this.getData())
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    getData() {
      const data = new FormData()
      const jsonObject = {
        languages: this.item.languages.filter(x => x.mle_description !== undefined && x.mle_description.trim().length > 0),
        mur_name: this.form.getFieldValue('mur_name'),
        mur_url: this.form.getFieldValue('mur_url') === undefined || this.form.getFieldValue('mur_url').trim().length === 0 ? null : this.form.getFieldValue('mur_url'),
      }
      if (this.item.iae_id.new.length > 0) {
        data.append('image', this.item.iae_id.new[0], this.item.iae_id.new[0].name)
      } else {
        jsonObject.iae_id = this.form.getFieldValue('existing')
      }
      data.append('json', JSON.stringify(jsonObject))
      return data
    },
    handleChange(oldLanguage) {
      const foundObj = { manufacturer: false }
      const newObj = {
        manufacturer: {
          lge_id: oldLanguage,
          mle_description: this.form.getFieldValue('mle_description'),
        },
      }
      this.item.languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.languages[key] = newObj.manufacturer
          foundObj.manufacturer = true
          return true
        }
      })
      if (!foundObj.manufacturer) {
        this.item.languages.push(newObj.manufacturer)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
    beforeUpload(file) {
      this.item.iae_id.new = [file]
      return false
    },
    handleRemove() {
      this.item.iae_id.new = []
    },
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        const foundObj = { manufacturer: this.item.languages.find(x => x.lge_id === newValue) }
        const newObj = foundObj.manufacturer === undefined ? { mle_description: undefined } : { mle_description: foundObj.manufacturer.mle_description }
        this.form.setFieldsValue(newObj)
        this.form.validateFields()
      }
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
